export default __webpack_public_path__ + "static/media/hammer-black.d1d3f10c.svg";